export const ORIGIN = {
    FRONT: 'https://sdp-test-luna.cloudprintsolutions.com',
    PUBLISH: 'http://localhost:1214',
    LOCAL: 'https://staging.hpapps.ext.hp.com/api',
    DEV: 'https://sdp-dev.cloudprintsolutions.com/',
    STAGING: 'https://sdp-stage.cloudprintsolutions.com/',
    TEST: 'https://sdp-test.cloudprintsolutions.com',
    TEMPORARY_PROD: 'https://www2.hpcommandcenter.com',
    PROD: 'https://www.hpcommandcenter.com',
};

export const Constants = {
    LOCALE_LANG_MAP: {
        en_US: 'English',
        de_DE: 'German',
        fr_FR: 'French',
        it_IT: 'Italian',
        ko_KR: 'Korea',
        zh_CN: 'Simplified Chinese',
        es_ES: 'Spanish',
        zh_TW: 'Traditional Chinese',
        sv_SE: 'Swedish',
        da_DK: 'Danish',
        nn_NO: 'Norwegian',
        nl_NL: 'Dutch',
        fi_FI: 'Finnish',
        pt_PT: 'Portuguese',
        tr_TR: 'Turkish',
        pl_PL: 'Polish',
        ru_RU: 'Russian',
        cs_CZ: 'Czech',
        hu_HU: 'Hungarian',
        ja_JP: 'Japanese',
        el_GR: 'Greek',
        hr_HR: 'Croatian',
        ro_RO: 'Romanian',
        sk_SK: 'Slovak',
        sl_SI: 'Slovenian',
        ca_ES: 'Catalan',
        th_TH: 'Thai',
        in_ID: 'Indonesian',
        he_IL: 'Hebrew',
        ar_SA: 'Arabic',
    },
    SUPPORT_LINK_LANG_MAP: {
        en_US: 'us-en',
        de_DE: 'de-de',
        fr_FR: 'fr-fr',
        it_IT: 'it-it',
        pt_PT: 'pt-pt',
        es_ES: 'es-es',
        ko_KR: 'kr-ko',
        zh_TW: 'tw-zh',
        vi_VN: 'vn-en',
        in_ID: 'id-en',
        ja_JP: 'jp-ja',
        th_TH: 'th-en',
    },
    LOCALE_LANG_DEFAULT: 'en_US',
    EMPTY_STRING: '',
    EMPTY_OBJECT: {},
    TABLE_ROW_HEIGHT: {
        TALL: 89,
        DEFAULT: 52,
        HIGH: 50,
        MEDIUM: 45,
        LOW: 40
    },
    CARD_TABLE_DEFAULT_ITEM_NUMBER_PER_ROW: 6,
    DEMO_POOL_ACCOUNT_NAME: 'Demo Pool',
    APP: {
        VENDOR_NAME: {
            HP: 'HP Inc.'
        },
        LICENSE_TYPE: {
            FREE: 'None',
            LICENSED: 'Licensed'
        },
        TYPE: {
            PRIVATE: 'Private',
            PUBLISHED: 'Published'
        }
    },
    GOOGLE_ANALYTICS_ID:
        (window.location.origin === ORIGIN.DEV) ? 'UA-117341830-8' :
        (window.location.origin === ORIGIN.STAGING) ? 'UA-117341830-7' :
        (window.location.origin === ORIGIN.TEST) ? 'UA-117341830-6' :
        (window.location.origin === ORIGIN.TEMPORARY_PROD) ?
        'UA-117341830-9' :
        (window.location.origin === ORIGIN.PROD) ?
        'UA-117341830-9' : 'UA-117341830-8',
    LIMIT_CONNECTION_TIME: 3 * 24 * 60 * 60 * 1000,
    VALID_HP_CARTRIDGE_STATUS_ARRAY: ["Unknown", "CartridgeInBadState",
        "NotSupported", "GenuineHP"
    ],
    MY_ACCOUNT_PORTAL_URL:
        (window.location.origin === ORIGIN.TEMPORARY_PROD ||
            window.location.origin === ORIGIN.PROD) ?
        'https://myaccount.id.hp.com/uaa' : 'https://myaccount.stg.cd.id.hp.com/uaa',

    JETADVANTAGE_URL: "https://jetadvantagesupport.ext.hp.com/hc/",
    FOR_VHTML: true,
    NOT_FOR_VHTML: false,
    VERSION: {
        EQUAL: 0,
        LESS_THAN: -1,
        GREATER_THAN: 1,
    },
    BASE64_ENCODED_IMAGE_PREFIX: 'data:image.png;base64,',

    TERMS_OF_SERVICES_SUPPORTED_LANGUAGE_LIST: ['en_US', 'es_ES', 'pt_PT', 'fr_FR', 'de_DE', 'it_IT', 'zh_TW', 'tr_TR'],

    getTermsOfServiceLink(currentLanguage) {
        return `https://docs.hpcommandcenter.com/${currentLanguage}/tc.html`
    },
    getPrivacyLink(currentLanguage) {
        const language = currentLanguage.toString().substring(0, 2);
        const country = currentLanguage.toString().substring(3, 5).toLowerCase();
        return `https://www8.hp.com/${country}/${language}/privacy/privacy.html`
    },
};

export const API = {
    BASE_URL:
        (window.location.origin === ORIGIN.PUBLISH) ? 'publish' : window.location.origin,
    SUBSCRIPTION_BASE_URL:
        (window.location.origin === ORIGIN.DEV) ?
        'https://subscription-dev.cloudprintsolutions.com' :
        (window.location.origin === ORIGIN.STAGING) ?
        'https://subscription-stage.cloudprintsolutions.com' :
        (window.location.origin === ORIGIN.TEST) ?
        'https://subscription-test.cloudprintsolutions.com' :
        (window.location.origin === ORIGIN.TEMPORARY_PROD) ?
        'https://subscription.hpcommandcenter.com' :
        (window.location.origin === ORIGIN.PROD) ?
        'https://subscription.hpcommandcenter.com' : 'https://subscription-dev.cloudprintsolutions.com',

    // accounts
    ACCOUNTS: '/accounts',
    ACCOUNTS_ID: '/accounts/${id}',
    ACCOUNTS_ID_ASSIGNED_USERS: '/accounts/${id}/assignedUsers',
    ACCOUNTS_LIST: '/accounts/list',
    ACCOUNTS_LIST_CONTRACTUAL: '/accounts/list/contractual',
    ACCOUNTS_LIST_DIRECT: '/accounts/list/direct',
    ACCOUNTS_ASSIGN_ID: '/accounts/assign/${id}',
    ACCOUNTS_DELEGATE_ID: '/accounts/delegate/${id}',
    ACCOUNTS_DISPOSABLE_ID: '/accounts/disposable/${id}',
    ACCOUNTS_FAVORITE: '/accounts/favorite',

    // solutions
    SOLUTIONS: '/solutions',
    SOLUTIONS_ID: '/solutions/${id}',
    SOLUTIONS_ID_ACCOUNT_ID: '/solutions/${id}/account/${id}',
    SOLUTIONS_ID_PERMISSION: '/solutions/${id}/permission',
    SOLUTIONS_ACCOUNT_ID: '/solutions/account/${id}',
    SOLUTIONS_LIST: '/solutions/list',
    SOLUTIONS_LIST_ACCOUNT_ID: '/solutions/list/account/${id}',
    SOLUTIONS_LIST_PRIVATE: '/solutions/list/private',
    SOLUTIONS_LIST_ACCOUNT_ID_AVAILABLE: '/solutions/list/account/${id}/available',

    // devices
    DEVICES: '/devices',
    DEVICES_ID: '/devices/${id}',
    DEVICES_ACCOUNT_ID: '/devices/account/${id}',
    DEVICES_ACCOUNT_ID_SIO_DOMAIN: '/devices/account/${id}/sioDomain',
    DEVICES_LOG_URL_ID_ID: '/devices/${id}/log/solution/${id}',
    DEVICES_LOG_TASK_LIST: '/devices/${id}/log',
    DEVICES_DISCONNECT: '/devices/disconnect',
    DEVICES_LIST_TASK_ID: '/devices/list/task/${id}',
    DEVICES_LIST_ASSIGNED: '/devices/list/assigned',
    DEVICES_LIST_NOT_ASSIGNED: '/devices/list/notAssigned',
    DEVICES_LIST_ACCOUNT_ID: '/devices/list/account/${id}',
    DEVICES_LIST_ACCOUNT_ID_DEVICE_FW: '/devices/list/account/${id}/device/fw',
    DEVICES_LIST_ACCOUNT_ID_SOLUTION_ID: '/devices/list/account/${id}/solution/${id}',
    DEVICES_LIST_ACCOUNT_ID_SOLUTION_ID_INSTALLABLE: '/devices/list/account/${id}/solution/${id}/installable',
    DEVICES_LIST_ACCOUNT_ID_SOLUTION_ID_INSTALLED: '/devices/list/account/${id}/solution/${id}/installed',
    DEVICES_LIST_ACCOUNT_ID_SOLUTION_ID_CONFIGURABLE: '/devices/list/account/${id}/solution/${id}/configurable',
    DEVICES_LIST_ACCOUNT_ID_SERVICE_LINK_ENABLE: '/devices/list/account/${id}/service/link/enabled',
    DEVICES_LIST_ACCOUNT_ID_SERVICE_LINK_DISABLE: '/devices/list/account/${id}/service/link/disabled',
    DEVICES_LIST_ACCOUNT_ID_SERVICE_SIO_ENABLE: '/devices/list/account/${id}/service/sio/enabled',
    DEVICES_LIST_ACCOUNT_ID_SERVICE_SIO_DISABLE: '/devices/list/account/${id}/service/sio/disabled',
    DEVICES_MAP_SOLUTION_ID_ACCOUNT_INSTALLED_COUNT: '/devices/map/solution/${id}/account/installedCount',

    // fleet
    FLEET_ID: '/fleet/${id}',
    FLEET_ID_DETAIL: '/fleet/${id}/detail',
    FLEET_LIST: '/fleet/list',
    FLEET_LIST_ACCOUNT_ID_IN_PROCESS: '/fleet/list/account/${id}/IN_PROCESS',
    FLEET_LIST_ACCOUNT_ID_SCHEDULED: '/fleet/list/account/${id}/SCHEDULED',
    FLEET_LIST_ACCOUNT_ID_COMPLETE: '/fleet/list/account/${id}/COMPLETE',
    FLEET_LIST_ACCOUNT_ID_COMPLETE_WITH_ERROR: '/fleet/list/account/${id}/COMPLETE_WITH_ERROR',
    FLEET_LIST_ACCOUNT_ID_CANCELED: '/fleet/list/account/${id}/CANCELED',
    FLEET_LIST_HISTORY_ACCOUNT_ID: '/fleet/list/history/account/${id}',
    FLEET_GET_CONFIG_SOLUTION_FILE: '/remoteConfig/file',
    FLEET_REMOTE_CONFIG_APP_ID: '/remoteConfig/app/${id}',
    FLEET_LOG: '/fleet/request',
    FLEET_CHECK_TASK: '/fleet/request',
    FLEET_CREATE_REMOTE_CONFIG_TASK: '/remoteConfig/file/taskResult/${id}',
    FLEET_INSTALL_SOLUTION: '/fleet/request',
    FLEET_UNINSTALL_SOLUTION: '/fleet/request',
    FLEET_SET_CONFIG_SOLUTION: '/fleet/request',
    FLEET_SET_REMOTE_CONFIGURATION: '/remoteConfig/configuration',
    FLEET_SET_SERVICE_CONFIGURATION: '/fleet/serviceRequest',
    FLEET_FIRMWARE_UPDATE: '/fleet/deviceRequest',
    FLEET_SYNC_DEVICES: '/fleet/request',
    FLEET_PATCH_LOG_ID: '/fleet/${id}/downloaded',
    FLEET_UPLOAD_URL: '/remoteConfig/uploadUrl',

    // users
    USERS: '/users',
    USERS_ID: '/users/${id}',
    USERS_LIST: '/users/list',
    USERS_LIST_ROLE_ROLE_SERVICE_PROVIDER_USER: '/users/list/role/ROLE_SERVICE_PROVIDER_USER',
    USERS_LIST_ROLE_ROLE_DMPS_TECH_CONSULTANT: '/users/list/role/ROLE_DMPS_TECH_CONSULTANT',
    USERS_INVITE_ID: '/users/invite/${id}',
    USERS_ON_BOARDING: '/users/onboarding',
    USERS_ID_CONSENT: '/users/${id}/consent',
    USERS_SUPPORT: '/users/support',

    // end users
    END_USERS: '/endUsers',
    END_USERS_LIST_ACCOUNT_ID: '/endUsers/list/account/${id}',
    END_USERS_ACCOUNT_ID: '/endUsers/account/{id}',
    END_USERS_VERIFY_ID: '/endUsers/verify/${id}',
    END_USERS_VERIFY_ACCOUNT_ID: '/endUsers/verify/account/${id}',
    END_USERS_IMPORT_ACCOUNT_ID: '/endUsers/import/account/${id}',
    END_USERS_IMPORT_FINISHED_ID: '/endUsers/import/finished/${id}',
    END_USERS_INVITED: '/endUsers/invited',
    END_USERS_INVITE: '/endUsers/invite',

    // apps
    APPS_ID: '/apps/${id}',
    APPS_LIST: '/apps/list',
    APPS_LIST_FEATURED: '/apps/list/featured',
    APPS_HISTORY_ID: '/apps/history/${id}',

    // filters
    FILTERS_ACCOUNT: '/filters/account',
    FILTERS_TASK: '/filters/task',
    FILTERS_DEVICE: '/filters/device',
    FILTERS_USER: '/filters/user',
    FILTERS_PARTNER_ACCOUNT: '/filters/partnerAccount',
    FILTERS_APP: '/getFilterParam',
    // session
    SESSION: '/session',
    SESSION_LOGOUT: '/session/logout',
    SESSION_USER_CODE: '/session/userCode',

    // report
    REPORT_AVAILABLE_DATE: '/report/availableDate',
    REPORT_DOWNLOAD: '/report/download',

    // pages
    PAGES_VISITED: '/pages/visited',

    // v1
    V1_SIGNUP: '/v1/signup',

    // support
    SSO_ZENDESK: '/sso/zendesk',

    // request method
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',

    SUCCESS: 'success',
    ERROR: 'ERROR',
};

export const ORDER = {
    ASC: 'asc',
    DESC: 'desc',
    NEWEST: 'newest',
    PRIVATE: 'private'
};

export const TABLE = {
    FIELD_NAME: {
        COMMON: {
            CHECKBOX: 'checkbox',
            STATUS: 'status', // AccountResponse, UserInfoResponse, DeviceResponse, FleetTaskHistory
            FAVORITE: 'favorite', // AccountResponse, SolutionResponse, DeviceResponse
            DATE_CREATED: 'dateCreated', // AccountResponse, UserInfoResponse, SolutionResponse
            REGION_ID: 'regionId', // AccountResponse, UserInfoResponse
            SOLUTION_NAME: 'solutionName', // AccountResponse, SolutionResponse
            DATE_UPDATED: 'dateUpdated', // UserInfoResponse, SolutionResponse
            NAME: 'name', // AppInfoResponse, User(not existing in UserInfoResponse)
            ACCOUNT_NAME: 'accountName', // AccountResponse, FleetTaskHistory
            COUNTRY: 'countrySet', // AccountResponse, UserInfoResponse
            FIRST_NAME: 'firstName',
            LAST_NAME: 'lastName',
        },
        USER: {
            EMAIL: 'email',
            PHONE_NUMBER: 'phoneNumber',
            ROLE: 'role', // not existing in UserInfoResponse
        },
        APP: {
            LAST_UPDATE_TIME: 'lastUpdateTime',
        },
        SOLUTION: {
            SOLUTION_NAME: 'solutionName',
            VENDOR_NAME: 'vendorName',
        },
        ACCOUNT: {
            CONTACT_EMAIL_ADDRESS: 'contactEmailAddress',
            SOLUTION_COUNT: 'solutionCount',
            DEVICE_COUNT: 'deviceCount'
        },
        DEVICE: {
            ASSET_NUMBER: 'assetNumber',
            FIRMWARE_VERSION: 'firmwareVersion',
            MODEL_NAME: 'modelName',
            SERIAL_NUMBER: 'serialNumber',
            LOCATION: 'location',
            ASSIGNED_ACCOUNT_NAME: 'assigned',
            IP_ADDRESS: 'ipAddress',
            INSTALLED_APP_COUNT: 'installedAppCount',
            LINK_ENABLED: 'isLinkForDeviceEnabled',
            SIGN_IN_ONCE_FOR_LINK_ENABLED: 'sioEnabled',
        },
        TASK: {
            CREATED_BY: "ownerEmail",
            DEVICES: "totalDeviceNo",
            TYPE: "taskType",
            CREATE_DATE_TIME: "createDateTime",
            START_DATE_TIME: "startDateTime",
            END_DATE_TIME: "endDateTime",
        }
    },
    ID: {
        ACCOUNTS: {
            DEFAULT: 'accountsTableId',
            CREATE_ACCOUNT: {
                USERS: 'accounts_createUser_usersTableId'
            }
        },
        PARTNER_ACCOUNTS: 'partnerAccountsTableId',
        USERS: {
            DEFAULT: 'usersTableId',
            CREATE_USER: {
                ACCOUNTS: 'users_createUser_accountsTableId'
            }
        },
        TASKS: {
            DEFAULT: 'tasksTableId',
            DETAIL: {
                DEVICES: 'taskDetail_devices_tasksTableId'
            }
        },
        ACCOUNT_DETAIL: {
            USERS: 'accountDetail_usersTableId',
            SOLUTIONS: 'accountDetail_solutionsTableId',
            DEVICES: 'accountDetail_devicesTableId',
            MANAGE_SOLUTIONS: {
                MANAGE: 'accountDetail_manageSolutions_manageTableId',
                INSTALL: 'accountDetail_manageSolutions_installTableId',
                UNINSTALL: 'accountDetail_manageSolutions_uninstallTableId',
                CONFIGURE: 'accountDetail_manageSolutions_configureTableId',
                SET_CONFIGURATION: 'accountDetail_manageSolutions_set_configurationTableId',
            },
            MANAGE_SERVICES: {
                MANAGE_LINK: 'accountDetail_manageServices_manageLinkTableId',
                MANAGE_SIO: 'accountDetail_manageServices_manageSioTableId',
                SIGN_IN_ONCE_FOR_LINK_ENABLE: 'accountDetail_manageServices_signInOnceForLink_enableTableId',
                LINK_ENABLE: 'accountDetail_manageServices_link_enableTableId',
                LINK_ENABLE_TARGET_DEVICE: 'accountDetail_manageServices_link_enable_target_deviceTableId',
                SIGN_IN_ONCE_FOR_LINK_DISABLE: 'accountDetail_manageServices_signInOnceForLink_disableTableId',
                LINK_DISABLE: 'accountDetail_manageServices_link_disableTableId',
            },
            MANAGE_FIRMWARES: {
                MANAGE: 'accountDetail_manageFirmwares_manageTableId',
                UPDATE: 'accountDetail_manageFirmwares_updateTableId'
            },
            TASKS: 'accountDetail_tasksTableId',
            IN_PROCESS_TASKS: 'accountDetail_inProcess_tasksTableId',
            SCHEDULED_TASKS: 'accountDetail_scheduled_tasksTableId',
            SUCCEEDED_TASKS: 'accountDetail_succeeded_tasksTableId',
            FAILED_TASKS: 'accountDetail_failed_tasksTableId',
            CANCELED_TASKS: 'accountDetail_canceled_tasksTableId',
            ADD_SOLUTIONS: 'accountDetail_addSolutionsTableId',
            ADD_DEVICES: 'accountDetail_addDevicesTableId',
            ADD_DEVICES_ON_DEMO_POOL: 'accountDetail_addDevicesOnDemoPoolTableId',
        },
        DEVICES: {
            DELETE_DEVICES: 'devices_deleteDevicesTableId',
            DISCONNECT_DEVICES: 'devices_disconnectDevicesTableId',
            NOT_ASSIGNED: 'devices_notAssignedTableId',
            ASSIGNED: 'devices_assignedTableId',
            INSTALLED_SOLUTIONS_LIST: 'installed_solutionsListTableId'
        },
        SOLUTIONS: {
            SOLUTION_PORTFOLIO: 'solutions_solutionPortfolioTableId',
            SOLUTIONS_CATALOG: 'solutions_solutionsCatalogTableId',
        },
        END_USERS: {
            DEFAULT: 'endUsersTableId',
        }
    },
    isManageSolutionsTable(tableId) {
        return (TABLE.ID.ACCOUNT_DETAIL.MANAGE_SOLUTIONS.MANAGE === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SOLUTIONS.INSTALL === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SOLUTIONS.UNINSTALL === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SOLUTIONS.CONFIGURE === tableId);
    },
    isManageServicesTable(tableId) {
        return (TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.MANAGE === tableId);
    },
    isManageServicesLinkTable(tableId) {
        return (TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.MANAGE_LINK === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.LINK_ENABLE === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.LINK_DISABLE === tableId);
    },
    isManageServicesSignInOnceForLinkTable(tableId) {
        return (TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.MANAGE_SIO === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.SIGN_IN_ONCE_FOR_LINK_ENABLE ===
            tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_SERVICES.SIGN_IN_ONCE_FOR_LINK_DISABLE ===
            tableId);
    },
    isManageFirmwaresTable(tableId) {
        return (TABLE.ID.ACCOUNT_DETAIL.MANAGE_FIRMWARES.MANAGE === tableId ||
            TABLE.ID.ACCOUNT_DETAIL.MANAGE_FIRMWARES.UPDATE === tableId);
    },
};

export const LINK = {
    ROOT: "/",

    // eula
    EULA: "/eula",

    // error
    ERROR: "/error",

    // auth
    CLAIM: "/claim",

    // landing
    LANDING: "/landing",

    // support
    SUPPORT: "/support",

    // my profile
    USERS_MY_PROFILE: "/users/myProfile",

    // devices assigned
    DEVICES_ASSIGNED: "/devices/assigned",

    // direct partner account
    PARTNER_ACCOUNTS_DIRECT: "/partnerAccounts/direct",

    // main
    SOLUTIONS_MAIN: "/solutions/main",
    PARTNER_ACCOUNTS_MAIN: "/partnerAccounts/main",
    ACCOUNTS_MAIN: "/accounts/main",
    USERS_MAIN: "/users/main",
    DEVICES_MAIN: "/devices/main",
    REPORT_MAIN: "/report/main",
    TASKS_MAIN: "/tasks/main",
    END_USERS_MAIN: "/endUsers/main",

    // detail
    APPS_DETAIL: "/apps/detail/",
    PARTNER_ACCOUNTS_DETAIL: "/partnerAccounts/detail/",
    ACCOUNTS_DETAIL: "/accounts/detail/",
    USERS_DETAIL: "/users/detail/",
    DEVICES_DETAIL: "/devices/detail/",
    TASKS_DETAIL: "/tasks/detail/"
};

export const TASK = {
    TYPE: {
        INSTALL: 1,
        UNINSTALL: 2,
        CONFIGURE: 3,
        ENABLE: 4,
        DISABLE: 5,
        UPDATE: 6,
    },
    STATUS: {
        IN_PROCESS: 'IN_PROCESS',
        SCHEDULED: 'SCHEDULED',
        COMPLETE: 'COMPLETE',
        CANCELED: 'CANCELED',
        COMPLETE_WITH_ERROR: 'COMPLETE_WITH_ERROR'
    },
    REMOTE_OPERATION_REQUEST_INFO_TYPE: {
        INSTALL: "INSTALL",
        UNINSTALL: "UNINSTALL",
        CONFIGURE: "CONFIGURE",
        GET_CONFIG: "RETRIEVE_CONFIG",
        ENABLE: "ENABLE",
        DISABLE: "DISABLE",
        UPDATE: "FIRMWARE_UPDATE",
    },
    SERVICE: {
        TYPE: {
            LINK: "SmartSolutionsPlatform",
            SIGN_IN_ONCE_FOR_LINK: "SmartCloudServices"
        },
        SPECIFY_EMAIL_DOMAIN: "accountLinkingEmailDomains"
    },
    getStringKeyFromTaskType(taskType) {
        switch (taskType) {
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.INSTALL:
                return "global.install";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.UNINSTALL:
                return "global.uninstall";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.CONFIGURE:
                return "global.configure";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.ENABLE:
                return "global.enable";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.DISABLE:
                return "global.disable";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.UPDATE:
                return "global.update";
            default:
                return Constants.EMPTY_STRING;
        }
    },
    getNounStringKeyFromTaskType(taskType) {
        switch (taskType) {
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.INSTALL:
                return "tasks.installation";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.UNINSTALL:
                return "tasks.uninstallation";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.CONFIGURE:
                return "devices.configuration";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.ENABLE:
                return "tasks.service.enable";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.DISABLE:
                return "tasks.service.disable";
            case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.UPDATE:
                return "global.update";
            default:
                return Constants.EMPTY_STRING;
        }
    },

    // refer to net.coresvcs.core.ws.v2.fleetmgt.RemoteOperationTask
    getGeneralStatusOrStringKeyFromArrakisStatus(arrakisStatus, isStatus) {
        switch (arrakisStatus) {
            case "NotStarted":
            case "Scheduled":
            case "Queued":
            case "Prepared":
                return isStatus ? TASK.STATUS.SCHEDULED : "global.scheduled";
            case "Executing":
                return isStatus ? TASK.STATUS.IN_PROCESS : "tasks.state.in.process";
            case "Completed":
                return isStatus ? TASK.STATUS.COMPLETE : "tasks.state.succeeded";
            case "CompletedWithErrors":
            case "Aborted":
                return isStatus ? TASK.STATUS.COMPLETE_WITH_ERROR : "tasks.failed";
            case "Cancelled": // RemoteOperationTask State
                return isStatus ? TASK.STATUS.CANCELED : "tasks.state.canceled";
            default:
                return Constants.EMPTY_STRING;
        }
    },

    // refer to net.coresvcs.core.ws.v2.fleetmgt.RemoteOperationResult
    getGeneralResultStatusOrStringKeyFromArrakisStatus(arrakisStatus, isStatus,
        taskType) {
        switch (arrakisStatus) {
            case "NotStarted":
            case "Scheduled":
            case "Queued":
            case "Prepared":
                return isStatus ? TASK.STATUS.SCHEDULED : "global.scheduled";
            case "Executing":
                return TASK.getInProcessStatusOrStringKey(taskType, isStatus);
            case "Completed":
                return isStatus ? TASK.STATUS.COMPLETE : "tasks.state.succeeded";
            case "CompletedWithErrors":
            case "Aborted":
                return isStatus ? TASK.STATUS.COMPLETE_WITH_ERROR : "tasks.failed";
            case "Cancelled": // RemoteOperationResult State
                return isStatus ? TASK.STATUS.CANCELED : "tasks.state.canceled";
            default:
                return Constants.EMPTY_STRING;
        }
    },

    getInProcessStatusOrStringKey(taskType, isStatus) {
        if (isStatus) {
            return TASK.STATUS.IN_PROCESS;
        } else {
            switch (taskType) {
                case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.INSTALL:
                    return "tasks.state.installing";
                case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.UNINSTALL:
                    return "tasks.state.uninstalling";
                case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.CONFIGURE:
                    return "tasks.state.configuring";
                case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.ENABLE:
                    return "tasks.state.enabling";
                case TASK.REMOTE_OPERATION_REQUEST_INFO_TYPE.DISABLE:
                    return "tasks.state.disabling";
                default:
                    return "tasks.state.in.process";
            }
        }
    },
    GET_GENERAL_STATUS: true,
    GET_GENERAL_STATUS_STRING_KEY: false,
};

export const ERROR_DESCRIPTION = {
    NOT_FOUND: 'NOT_FOUND',
    NOT_VERIFIED: 'NOT_VERIFIED',
    NOT_ACTIVATED: 'NOT_ACTIVATED',
};

export const ERROR_CODE = {
    SERVICE_CODE_HPCC: '0000',
    SERVICE_CODE_ARRAKIS: '0001',
    SERVICE_CODE_SDPSVCS: '0002',
    SERVICE_CODE_MONET: '0003',

    COMMON_ERROR_CODE: '0000',
    UNKNOWN_ERROR_CODE: '9999',

    ACCOUNT_DUPLICATE: 'CCW0000U0005',
    SESSION_EXPIRED: 'CCW0000U0001',
};

export const ERROR_ADDITIONAL_INFO = {
    TENANT_DUPLICATE_INFO: 'net.coresvcs.core.ws.v2.tenantmgt.Tenant',
    USER_DUPLICATE_INFO: 'net.coresvcs.core.ws.v2.usermgt.users.User'
};

export const SERVICE_NAME = {
    SIO: 'Sign in once for Link',
    LINK: 'Link',
    FIRMWARE: 'Firmware',
};

export const PRECONDITION_TYPE = {
    SIMPLE: 'simple',
};

export const LOG_TASK_STATUS = {
    NO_TASK: null,
    QUEUED: 'Queued',
    EXECUTING: 'Executing',
    COMPLETED: 'Completed',
};

export const ICON_TYPE = {
    INFO: 'hpInfoIcon',
    WARNING: 'hpWarningIcon',
    HELP: 'hpHelpIcon',
    INFO_SMALL: 'hpInfoSmallIcon',
    RESTRICTED_SMALL: 'hpRestrictedSmallIcon',
    BLOCKED_SMALL: 'hpBlockedSmallIcon',
};

export const DEVICE = {
    STATUS: {
        COMMON: {
            ALL: 'ALL',
            IN_PROCESS: 'IN_PROCESS',
            CONSTRAINED: 'CONSTRAINED',
            UPDATES_AVAILABLE: 'UPDATES_AVAILABLE'
        },
        SOLUTION: {
            NOT_INSTALLED: 'NOT_INSTALLED',
            INSTALLED: 'INSTALLED',
        },
        SERVICE: {
            ENABLED: 'ENABLED',
            DISABLED: 'DISABLED',
            UPDATE_DOMAIN: 'UPDATE_DOMAIN',
        },
        FIRMWARE: {
            UP_TO_DATE: 'UP_TO_DATE',
        },
        TASK: {
            FAILED: 'FAILED',
            SUCCEEDED: 'SUCCEEDED',
            CANCELED: 'CANCELED',
        }
    },
};
export const DATE_FORMAT = {
    YYYY_MM_DD: 'YYYYMMDD',
    MMMM_YYYY: 'MMMM YYYY',
    DD_MMM_YYYY: 'DD MMM YYYY',
    HH_MM_DD_MMM_YYYY: 'hh:mm A on DD MMM YYYY',
    DD_MMM_YYYY_HH_MM: 'DD/MMM/YYYY, hh:mm A',
    DD_MM_YYYY: 'DD/MM/YYYY',
    HH_MM_DD_MM_YYYY: 'hh:mm A [at] DD/MM/YYYY',
    DD_MM_YYYY_HH_MM: 'DD/MM/YYYY, hh:mm A',
    HH_MM: 'hh:mm A',
};

export const FILTER = {
    RESOURCE_ID: 'RESOURCE_ID',
};

export const SERVICE_CONTENT_NAME = {
    SUPPORT_NAME: "hpcc.service.extension.dashboard.support.name.key",
};
export const DATA_COLLECTION_STATUS = {
    INITIAL_SYNCING: 'Initial Syncing',
    INITIAL_SYNCING_FAILED: 'Initial Syncing Failed',
    SYNC_SUCCEED: 'Sync Succeed',
    INSTANT_SYNCING: 'Instant Syncing',
    INSTANT_SYNCING_FAILED: 'Instant Syncing Failed',
};

export const INITIAL_SYNCING = {
    END_STATUS_CASE: ['Completed', 'CompletedWithErrors'],
};

export const REQUEST_DATA_TYPE = {
    SOLUTION_LOG: 'SOLUTION_LOG',
    INSTANT_SYNC: 'INSTANT_SYNC',
};

export const VENDOR_NAME = {
    CONTACT_EMAIL_ADDRESS: ['external.groups.hp.com', 'hp.com'],

    isHpVendor(contactEmail) {
        return VENDOR_NAME.CONTACT_EMAIL_ADDRESS.includes(contactEmail.split('@')[1]);
    }
};

export const LICENSE_TYPE = {
    PREMIUM_VENDOR: 'HP Inc.',
    PREMIUM: 'HP Workpath Premium',
    ESSENTIAL: 'HP Workpath Essential',

    fromVendor(vendorName) {
        return vendorName === LICENSE_TYPE.PREMIUM_VENDOR ? LICENSE_TYPE.PREMIUM : LICENSE_TYPE.ESSENTIAL;
    }
};